import DeviceForFreeTooltip from './DeviceForFreeTooltip';

export default DeviceForFreeTooltip;
